/**
 * 69 wilayas d'Algérie (Loi n° 26-06, JO 2026) — ordre officiel par code + Autre
 * @see https://fr.wikipedia.org/wiki/Wilayas_d%27Alg%C3%A9rie
 */
export const ALGERIAN_WILAYAS = [
  'Adrar', // 01
  'Chlef', // 02
  'Laghouat', // 03
  'Oum El Bouaghi', // 04
  'Batna', // 05
  'Béjaïa', // 06
  'Biskra', // 07
  'Béchar', // 08
  'Blida', // 09
  'Bouira', // 10
  'Tamanrasset', // 11
  'Tébessa', // 12
  'Tlemcen', // 13
  'Tiaret', // 14
  'Tizi Ouzou', // 15
  'Alger', // 16
  'Djelfa', // 17
  'Jijel', // 18
  'Sétif', // 19
  'Saïda', // 20
  'Skikda', // 21
  'Sidi Bel Abbès', // 22
  'Annaba', // 23
  'Guelma', // 24
  'Constantine', // 25
  'Médéa', // 26
  'Mostaganem', // 27
  "M'Sila", // 28
  'Mascara', // 29
  'Ouargla', // 30
  'Oran', // 31
  'El Bayadh', // 32
  'Illizi', // 33
  'Bordj Bou Arreridj', // 34
  'Boumerdès', // 35
  'El Tarf', // 36
  'Tindouf', // 37
  'Tissemsilt', // 38
  'El Oued', // 39
  'Khenchela', // 40
  'Souk Ahras', // 41
  'Tipaza', // 42
  'Mila', // 43
  'Aïn Defla', // 44
  'Naâma', // 45
  'Aïn Témouchent', // 46
  'Ghardaïa', // 47
  'Relizane', // 48
  'Timimoun', // 49
  'Bordj Badji Mokhtar', // 50
  'Ouled Djellal', // 51
  'Béni Abbès', // 52
  'In Salah', // 53
  'In Guezzam', // 54
  'Touggourt', // 55
  'Djanet', // 56
  "El M'Ghair", // 57
  'El Meniaa', // 58
  'Aflou', // 59
  'Barika', // 60
  'El Kantara', // 61
  'Bir El Ater', // 62
  'El Aricha', // 63
  'Ksar Chellala', // 64
  'Aïn Ouessara', // 65
  'Messaad', // 66
  'Ksar El Boukhari', // 67
  'Bou Saâda', // 68
  'El Abiodh Sidi Cheikh', // 69
  'Autre',
];

export const FRANCE_CITIES = [
  'Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes', 'Montpellier', 'Strasbourg',
  'Bordeaux', 'Lille', 'Rennes', 'Reims', 'Saint-Étienne', 'Toulon', 'Le Havre', 'Grenoble',
  'Dijon', 'Angers', 'Nîmes', 'Villeurbanne', 'Clermont-Ferrand', 'Le Mans', 'Aix-en-Provence',
  'Brest', 'Tours', 'Amiens', 'Limoges', 'Annecy', 'Perpignan', 'Metz', 'Besançon', 'Orléans',
  'Rouen', 'Mulhouse', 'Caen', 'Nancy', 'Avignon', 'Poitiers', 'Pau', 'La Rochelle', 'Cannes',
  'Antibes', 'Calais', 'Boulogne-Billancourt', 'Saint-Denis', 'Argenteuil', 'Montreuil',
  'Roubaix', 'Tourcoing', 'Nanterre', 'Créteil', 'Versailles', 'Colmar', 'Ajaccio', 'Bastia',
  'Fort-de-France', 'Cayenne', 'Saint-Denis (La Réunion)', 'Autre',
];

export const MOROCCO_CITIES = [
  'Casablanca', 'Rabat', 'Fès', 'Marrakech', 'Tanger', 'Agadir', 'Meknès', 'Oujda', 'Kenitra',
  'Tétouan', 'Safi', 'El Jadida', 'Beni Mellal', 'Nador', 'Khouribga', 'Mohammédia', 'Laâyoune',
  'Dakhla', 'Errachidia', 'Settat', 'Larache', 'Ksar El Kebir', 'Taza', 'Berkane', 'Khémisset',
  'Inezgane', 'Guelmim', 'Berrechid', 'Taourirt', 'Essaouira', 'Tiznit', 'Taroudant', 'Autre',
];

export const TUNISIA_CITIES = [
  'Tunis', 'Ariana', 'Ben Arous', 'Manouba', 'Nabeul', 'Zaghouan', 'Bizerte', 'Béja', 'Jendouba',
  'Le Kef', 'Siliana', 'Sousse', 'Monastir', 'Mahdia', 'Sfax', 'Kairouan', 'Kasserine',
  'Sidi Bouzid', 'Gabès', 'Médenine', 'Tataouine', 'Gafsa', 'Tozeur', 'Kébili', 'Autre',
];

export const CANADA_CITIES = [
  'Toronto', 'Montréal', 'Vancouver', 'Calgary', 'Edmonton', 'Ottawa', 'Winnipeg', 'Québec',
  'Hamilton', 'Kitchener', 'London', 'Victoria', 'Halifax', 'Oshawa', 'Windsor', 'Saskatoon',
  'Regina', "St. John's", 'Kelowna', 'Barrie', 'Sherbrooke', 'Guelph', 'Abbotsford', 'Kingston',
  'Trois-Rivières', 'Moncton', 'Milton', 'Red Deer', 'Brantford', 'Thunder Bay', 'Whitehorse',
  'Yellowknife', 'Iqaluit', 'Charlottetown', 'Fredericton', 'Laval', 'Longueuil', 'Gatineau',
  'Burnaby', 'Richmond', 'Surrey', 'Lévis', 'Saguenay', 'Terrebonne', 'Laval (QC)', 'Markham',
  'Vaughan', 'Mississauga', 'Brampton', 'Oakville', 'Sudbury', 'Chicoutimi', 'Drummondville',
  'Granby', 'Saint-Jean-sur-Richelieu', 'Rimouski', 'Val-d\'Or', 'Sept-Îles', 'Châteauguay',
  'Nanaimo', 'Kamloops', 'Prince George', 'Lethbridge', 'Medicine Hat', 'Grande Prairie',
  'Saint John', 'Dartmouth', 'Sydney (NS)', 'Corner Brook', 'Brandon', 'Moose Jaw', 'Autre',
];

export const BELGIUM_CITIES = [
  'Bruxelles', 'Anvers', 'Gand', 'Charleroi', 'Liège', 'Bruges', 'Namur', 'Louvain', 'Mons',
  'Malines', 'Alost', 'La Louvière', 'Courtrai', 'Hasselt', 'Ostende', 'Genk', 'Seraing',
  'Roeselare', 'Verviers', 'Mouscron', 'Tournai', 'Dilbeek', 'Saint-Nicolas', 'Waregem',
  'Braine-l\'Alleud', 'Nivelles', 'Wavre', 'Arlon', 'Bastogne', 'Marche-en-Famenne',
  'Waterloo', 'Turnhout', 'Geel', 'Halle', 'Vilvorde', 'Herstal', 'Châtelet', 'Beveren',
  'Dendermonde', 'Lokeren', 'Sint-Truiden', 'Lierre', 'Herentals', 'Maasmechelen', 'Temse',
  'Ypres', 'Knokke-Heist', 'Blankenberge', 'Deinze', 'Eupen', 'Huy', 'Spa', 'Ath', 'Comines-Warneton',
  'Tubize', 'Soignies', 'Binche', 'Fontaine-l\'Évêque', 'Fleurus', 'Gerpinnes', 'Philippeville',
  'Couvin', 'Dinant', 'Ciney', 'Rochefort', 'Neufchâteau', 'Virton', 'Saint-Hubert', 'Hannut',
  'Waremme', 'Flémalle', 'Ans', 'Grâce-Hollogne', 'Fléron', 'Beyne-Heusay', 'Soumagne', 'Visé',
  'Dour', 'Colfontaine', 'Quaregnon', 'Frameries', 'Jurbise', 'Enghien', 'Lessines',
  'Leuze-en-Hainaut', 'Péruwelz', 'Antoing', 'Braine-le-Comte', 'Écaussinnes', 'Manage', 'Seneffe',
  'Autre',
];

export const CITIES_BY_COUNTRY = {
  Algérie: ALGERIAN_WILAYAS,
  France: FRANCE_CITIES,
  Maroc: MOROCCO_CITIES,
  Tunisie: TUNISIA_CITIES,
  Canada: CANADA_CITIES,
  Belgique: BELGIUM_CITIES,
  Autre: ['Autre'],
};

export const DEFAULT_COUNTRY = 'Algérie';

export const CONTACT_COUNTRIES = [
  'Algérie',
  'France',
  'Maroc',
  'Tunisie',
  'Canada',
  'Belgique',
  'Autre',
];

function withoutVieuxKouba(list) {
  return (list || []).filter((item) => item !== 'Vieux Kouba');
}

export function resolveCityOptions(country, cmsAlgeriaCities) {
  if (country === 'Algérie') {
    return withoutVieuxKouba(ALGERIAN_WILAYAS);
  }
  if (Array.isArray(cmsAlgeriaCities) && cmsAlgeriaCities.length > 0 && country !== 'Algérie') {
    return cmsAlgeriaCities;
  }
  return CITIES_BY_COUNTRY[country] || ['Autre'];
}

export function resolveCountryOptions(cmsCountries) {
  if (Array.isArray(cmsCountries) && cmsCountries.length > 0) {
    return cmsCountries;
  }
  return CONTACT_COUNTRIES;
}

export function resolveDefaultCountry(cmsDefault) {
  return cmsDefault || DEFAULT_COUNTRY;
}

export function resolveCityPlaceholder(country) {
  return country === 'Algérie'
    ? 'Sélectionner votre wilaya'
    : 'Sélectionner votre ville';
}
